/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "ScreenSaverDelay": {
                                "values": {
                                  "SCREEN_SAVER_DELAY_UNSPECIFIED": 0,
                                  "SCREEN_SAVER_DELAY_5_MIN": 1,
                                  "SCREEN_SAVER_DELAY_10_MIN": 2,
                                  "SCREEN_SAVER_DELAY_15_MIN": 3,
                                  "SCREEN_SAVER_DELAY_30_MIN": 4
                                }
                              },
                              "ScreenSaverSettings": {
                                "fields": {
                                  "isEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "delay": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverDelay",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": "SCREEN_SAVER_DELAY_UNSPECIFIED"
                                    }
                                  },
                                  "customEntries": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntries",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ScreenSaverEntries": {
                                "fields": {
                                  "enabledEntries": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntry",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "disabledEntries": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntry",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "cycleTimeInMillis": {
                                    "type": "int64",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ScreenSaverEntry": {
                                "fields": {
                                  "text": {
                                    "type": "string",
                                    "id": 1
                                  },
                                  "cashtag": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntry.Cashtag",
                                    "id": 2
                                  }
                                },
                                "nested": {
                                  "Cashtag": {
                                    "fields": {
                                      "displayCashtag": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "entry": {
                                    "oneof": ["text", "cashtag"]
                                  }
                                }
                              },
                              "CashLocalSettings": {
                                "fields": {
                                  "isQuickClaimRewardsEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "isIdleScreensaverEnabled": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "screenSaverSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverSettings",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "customWelcomeString": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "isShowRewardsOnReceiptEnabled": {
                                    "type": "bool",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.ScreenSaverDelay && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.ScreenSaverSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.ScreenSaverEntries && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.ScreenSaverEntry && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.ScreenSaverEntry?.nested?.Cashtag && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.CashLocalSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE ScreenSaverDelay @ squareup/devicesettings/profiles/v2/model/settings/common/cash_local_settings.proto at 17:1
 */
export const ScreenSaverDelay = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverDelay').values;
/**
 * SOURCE ScreenSaverSettings @ squareup/devicesettings/profiles/v2/model/settings/common/cash_local_settings.proto at 25:1
 */
export const ScreenSaverSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverSettings');
fixType(ScreenSaverSettings);
Builder.createAndAttachToType(ScreenSaverSettings);
/**
 * Container for screensaver entries, separated into enabled and disabled buckets.
 * The order of entries in each list determines their display order.
 *
 * SOURCE ScreenSaverEntries @ squareup/devicesettings/profiles/v2/model/settings/common/cash_local_settings.proto at 39:1
 */
export const ScreenSaverEntries = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntries');
fixType(ScreenSaverEntries);
Builder.createAndAttachToType(ScreenSaverEntries);
/**
 * A single entry displayed on the screensaver.
 *
 * SOURCE ScreenSaverEntry @ squareup/devicesettings/profiles/v2/model/settings/common/cash_local_settings.proto at 52:1
 */
export const ScreenSaverEntry = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntry');
fixType(ScreenSaverEntry);
Builder.createAndAttachToType(ScreenSaverEntry);
/**
 * Represents a Cash App Cashtag (e.g., $seller).
 *
 * SOURCE Cashtag @ squareup/devicesettings/profiles/v2/model/settings/common/cash_local_settings.proto at 54:3
 */
ScreenSaverEntry.Cashtag = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.ScreenSaverEntry.Cashtag');
fixType(ScreenSaverEntry.Cashtag);
Builder.createAndAttachToType(ScreenSaverEntry.Cashtag);
/**
 * SOURCE CashLocalSettings @ squareup/devicesettings/profiles/v2/model/settings/common/cash_local_settings.proto at 66:1
 */
export const CashLocalSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.CashLocalSettings');
fixType(CashLocalSettings);
Builder.createAndAttachToType(CashLocalSettings);